import { preload } from './lib/_preload.js';
import { loc } from './lib/_location.js';
import { common } from './_common.js';
import { memoryGame } from './game/_memory_game.js';


export class Framework {
	constructor(){
		this.pageinfo = loc.all();
		this.nextpage = "";
		this.afterChangePage();
		//console.log(this.pageinfo);
	}
	
	afterChangePage(){
		common.init();
		common.resize();
		memoryGame.init();
	}
	
}